<template>
  <div class="user-page">
    <div class="toolbar">
      <el-input v-model="keyword" placeholder="搜索用户名/邮箱/手机" class="search" clearable />
      <el-button type="primary" @click="loadList">搜索</el-button>
      <el-button type="primary" @click="openCreate">新增用户</el-button>
    </div>
    <el-table :data="list" style="width:100%" stripe>
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="username" label="用户名" />
      <el-table-column prop="nickname" label="昵称" />
      <el-table-column prop="email" label="邮箱" />
      <el-table-column prop="mobile" label="手机" />
      <el-table-column prop="balance" label="余额" width="100" />
      <el-table-column prop="points" label="积分" width="100" />
      <el-table-column prop="vip_level_name" label="会员等级" />
      <el-table-column prop="vip_expire_at" label="等级过期时间" width="140">
        <template #default="{ row }">
          <span>{{ row.vip_expire_at ? new Date(row.vip_expire_at * 1000).toLocaleDateString() : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="feishu_open_id" label="飞书OpenID" width="160" show-overflow-tooltip />
      <el-table-column label="操作" width="180">
        <template #default="{row}">
          <el-button size="small" type="primary" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      :current-page="pagination.page"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      layout="prev, pager, next"
      @current-change="pageChange"/>

    <el-dialog v-model="dialogVisible" title="用户信息" width="400px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="用户名">
          <el-input v-model="form.username" autocomplete="off" />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email" autocomplete="off" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.mobile" autocomplete="off" />
        </el-form-item>
        <el-form-item label="余额">
          <el-input-number v-model="form.balance" :min="0" style="width:100%" />
        </el-form-item>
        <el-form-item label="积分">
          <el-input-number v-model="form.points" :min="0" :step="1" style="width:100%" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input type="password" v-model="form.password" autocomplete="off" placeholder="留空则不修改" />
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="form.nickname" autocomplete="off" />
        </el-form-item>
        <el-form-item label="会员等级">
          <el-select v-model="form.vip_level" style="width:100%">
            <el-option v-for="lvl in levelOptions" :key="lvl.id" :label="lvl.name" :value="lvl.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="到期时间">
          <el-date-picker v-model="form.vip_expire_at" type="date" value-format="X" placeholder="选择日期" style="width:100%" />
        </el-form-item>
        <el-form-item label="生日">
          <el-date-picker
            v-model="form.birth_month"
            type="date"
            value-format="X"
            placeholder="选择日期"
            style="width:100%" />
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="form.gender" placeholder="请选择">
            <el-option label="未知" value="未知" />
            <el-option label="男" value="男" />
            <el-option label="女" value="女" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" placeholder="请选择">
            <el-option label="禁用" :value="0" />
            <el-option label="启用" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="飞书OpenID">
          <el-input v-model="form.feishu_open_id" autocomplete="off" placeholder="飞书open_id" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submitForm">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { ElMessage } from 'element-plus';
import md5 from 'js-md5';
import request from '../../utils/request';

const list = ref([]);
const pagination = ref({ page: 1, pageSize: 30, total: 0 });
const keyword = ref('');
const dialogVisible = ref(false);
const loading = ref(false);
const levels = ref([]);
const levelOptions = computed(() => ([
  { id: 0, name: 'Lv0' },
  ...levels.value
    .map((item) => ({ id: Number(item.id), name: String(item.name || `Lv${item.id}`) }))
    .filter((item) => item.id !== 0)
]));
const form = ref({
  id: null,
  username: '',
  email: '',
  mobile: '',
  balance: 0,
  points: 0,
  password: '',
  nickname: '',
  vip_level: 0,
  vip_expire_at: '',
  birth_month: '',
  gender: '未知',
  status: 1,
  feishu_open_id: ''
});

const loadList = async () => {
  const params = { page: pagination.value.page, pageSize: pagination.value.pageSize, keyword: keyword.value };
  try {
    const data = await request.get('/v1/user/list', { params });
    list.value = data.list;
    pagination.value.total = data.pagination.total;
  } catch (e) {
    ElMessage.error(e.toString());
  }
  try {
    const lvl = await request.get('/v1/vip-level/list');
    levels.value = (lvl.list || []).filter((item) => Number(item.id) !== 0);
  } catch (e) {}
};

const pageChange = (p) => {
  pagination.value.page = p;
  loadList();
};

const openCreate = () => {
  form.value = {
    id: null,
    username: '',
    email: '',
    mobile: '',
    balance: 0,
    password: '',
    nickname: '',
    vip_level: 0,
    vip_expire_at: '',
    birth_month: '',
    gender: '未知',
    status: 1,
    feishu_open_id: ''
  };
  dialogVisible.value = true;
};

const edit = (row) => {
  form.value = {
    id: row.id,
    username: row.username,
    email: row.email,
    mobile: row.mobile,
    balance: row.balance || 0,
    points: Number(row.points ?? 0),
    password: '',
    nickname: row.nickname || '',
    vip_level: Number(row.vip_level ?? 0),
    vip_expire_at: row.vip_expire_at || '',
    birth_month: row.birth_month || '',
    gender: row.gender === 0 || row.gender === undefined
      ? '未知'
      : row.gender === 1
        ? '男'
        : row.gender === 2
          ? '女'
          : row.gender,
    status: row.status != null ? row.status : 1,
    feishu_open_id: row.feishu_open_id || ''
  };
  dialogVisible.value = true;
};

const submitForm = async () => {
  loading.value = true;
  try {
    const payload = { ...form.value };
    if (payload.gender === '未知') payload.gender = 0;
    else if (payload.gender === '男') payload.gender = 1;
    else if (payload.gender === '女') payload.gender = 2;
    if (payload.vip_expire_at) {
      const t1 = Number(payload.vip_expire_at);
      payload.vip_expire_at = t1 > 9999999999 ? Math.floor(t1 / 1000) : Math.floor(t1);
    }
    if (payload.birth_month) {
      const t2 = Number(payload.birth_month);
      payload.birth_month = t2 > 9999999999 ? Math.floor(t2 / 1000) : Math.floor(t2);
    }
    if (payload.password) payload.password = md5(payload.password);
    if (payload.status === '启用') payload.status = 1;
    else if (payload.status === '禁用') payload.status = 0;
    if (payload.id) {
      await request.post('/v1/user/update', payload);
      ElMessage.success('更新成功');
    } else {
      await request.post('/v1/user/create', payload);
      ElMessage.success('创建成功');
    }
    dialogVisible.value = false;
    loadList();
  } catch (e) {
    ElMessage.error(e.toString());
  } finally {
    loading.value = false;
  }
};

const remove = async (row) => {
  try {
    await request.post('/v1/user/delete', { id: row.id });
    ElMessage.success('删除成功');
    loadList();
  } catch (e) {
    ElMessage.error(e.toString());
  }
};

onMounted(loadList);
</script>

<style scoped>
.user-page .toolbar {
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
}
.search {
  width: 200px;
}
.pager {
  margin-top: 15px;
  text-align: right;
}
</style>
